var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkynetTechnologiesLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 219 91",
    style: {
      enableBackground: "new 0 0 219 91"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#420083;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,83.5c-0.5-0.4-1-0.5-1.4-0.7c-0.4-0.1-0.9-0.2-1.6-0.5C5.6,82,5,81.8,4.6,81.5c-0.4-0.2-0.5-0.4-0.5-0.7    c0-0.2,0.1-0.5,0.4-0.6c0.2-0.1,0.6-0.2,1-0.2c1,0,1.7,0.6,2.1,1.6l2.9-1.7c-0.5-1-1.2-1.7-2.1-2.3c-0.9-0.6-2-0.9-3.1-0.9    c-1.4,0-2.5,0.5-3.4,1.2c-0.9,0.7-1.4,1.8-1.4,3.1c0,1.1,0.2,2,1,2.7c0.7,0.7,1.7,1.2,3.1,1.6c1,0.2,1.5,0.4,1.7,0.5    c0.6,0.2,1,0.6,1,1c0,0.6-0.5,1-1.6,1c-1.2,0-2.2-0.6-2.7-1.8l-2.9,1.7c0.4,1.1,1.1,2.1,2.1,2.6c1,0.5,2.1,0.9,3.6,0.9    c1.6,0,2.8-0.4,3.7-1.4c1-0.7,1.5-1.8,1.5-3.2C10.9,85.1,10.4,84.1,9.4,83.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.8,82.8 15.8,77 12.2,77 12.2,90.8 15.8,90.8 15.8,84.6 19.7,90.8 23.5,90.8 19,83.6 23.4,77     19.6,77   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "29.8,82 27.3,77 23.4,77 28.1,85.5 28.1,90.8 31.6,90.8 31.6,85.5 36.3,77 32.4,77   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "45,83.9 40,77 37.3,77 37.3,90.8 40.8,90.8 40.8,83.9 45.8,90.8 48.5,90.8 48.5,77 45,77   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.2,85.4c0,0,4.7,0,4.7,0.1v-3.2h-4.8v-2h5.3V77h-8.7v13.8h8.8v-3.3h-5.3V85.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "60.3,80.4 63.6,80.4 63.6,90.8 67.1,90.8 67.1,80.4 70.6,80.4 70.6,77 60.3,77   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "75.4,77 75.4,80.4 78.8,80.4 78.8,90.8 82.4,90.8 82.4,80.4 85.8,80.4 85.8,77 75.5,77   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.6,85.4c0,0,4.7,0,4.7,0.1v-3.2h-4.8v-2h5.3V77H87v13.8h8.8v-3.3h-5.3V85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.1,79.9c0.6,0,1.2,0.1,1.7,0.4c0.5,0.2,0.9,0.6,1.1,1.1l3.1-1.7c-0.6-1-1.4-1.7-2.5-2.3    c-1.1-0.6-2.2-0.9-3.4-0.9c-2.1,0-3.8,0.7-5.2,2.1c-1.4,1.4-2.1,3.1-2.1,5.2c0,2.1,0.7,3.8,2.1,5.2c1.4,1.4,3.1,2.1,5.2,2.1    c1.2,0,2.5-0.2,3.4-1.1c1-0.5,1.8-1.4,2.5-2.3l-3.1-1.7c-0.2,0.4-0.6,0.9-1.1,1.1c-0.5,0.2-1.1,0.4-1.7,0.4c-1.1,0-2-0.2-2.7-1    c-0.6-0.6-1-1.6-1-2.7c0-1.1,0.4-2,1-2.7C102.1,80.3,103,79.9,104.1,79.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "118.7,82 114.8,82 114.8,77 111.2,77 111.2,90.8 114.8,90.8 114.8,85.5 118.7,85.5 118.7,90.8     122.1,90.8 122.1,77 118.7,77   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "132,83.9 127.1,77 124.4,77 124.4,90.8 127.9,90.8 127.9,83.9 132.7,90.8 135.4,90.8 135.4,77     132,77   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.3,76.6c-2.1,0-3.8,0.7-5.2,2.1c-1.4,1.4-2.1,3.1-2.1,5c0,2.1,0.7,3.8,2.1,5.2c1.4,1.4,3.1,2.1,5.2,2.1    c2.1,0,3.8-0.7,5.2-2.1c1.5-1.4,2.1-3.1,2.1-5.2c0-2-0.7-3.7-2.1-5C147.9,77.4,146.2,76.6,144.3,76.6z M147.1,86.6    c-0.7,0.6-1.6,1-2.7,1c-1.1,0-2-0.2-2.7-1c-0.7-0.7-1.1-1.6-1.1-2.7c0-1.1,0.4-2,1.1-2.7c0.7-0.7,1.6-1.1,2.7-1.1    c1.1,0,2,0.4,2.7,1.1c0.7,0.7,1.1,1.6,1.1,2.7C148.2,85,147.8,85.8,147.1,86.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "156.7,77 153.2,77 153.2,90.8 161.4,90.8 161.4,87.3 156.7,87.3   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.7,76.6c-2.1,0-3.8,0.7-5.2,2.1c-1.4,1.4-2.1,3.1-2.1,5c0,2.1,0.7,3.8,2.1,5.2c1.4,1.4,3.2,2.1,5.2,2.1    c2.1,0,3.8-0.7,5.2-2.1c1.4-1.4,2.1-3.1,2.1-5.2c0-2-0.7-3.7-2.1-5C172.4,77.4,170.7,76.6,168.7,76.6z M171.4,86.6    c-0.7,0.6-1.6,1-2.7,1c-1.1,0-2-0.2-2.7-1c-0.6-0.7-1-1.6-1.1-2.7c0-1.1,0.4-2,1.1-2.7c0.7-0.7,1.6-1.1,2.7-1.1    c1.1,0,2,0.4,2.7,1.1c0.7,0.7,1.1,1.6,1.1,2.7C172.5,85,172.1,85.8,171.4,86.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.3,86h3.3c-0.5,1.2-1.6,1.8-3.2,1.8c-1.2,0-2.2-0.4-2.9-1.1c-0.6-0.7-1-1.6-1-2.7c0-1.1,0.4-2,1.1-2.7    c0.7-0.7,1.6-1.1,2.7-1.1c0.7,0,1.4,0.1,1.8,0.4c0.5,0.2,1,0.6,1.2,1l2.9-1.7c-0.6-1-1.5-1.7-2.6-2.3c-1.1-0.6-2.3-0.9-3.6-0.9    c-2.1,0-3.8,0.7-5.2,2.1c-1.4,1.5-2.1,3.2-2.1,5.2c0,2,0.7,3.7,2.1,5c1.4,1.4,3.2,2.1,5.3,2.1c2,0,3.7-0.6,4.9-1.8    c1.4-1.2,2-2.9,2-4.9v-1.4h-6.9V86z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.8,
    y: 77,
    className: "st0",
    width: 3.6,
    height: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202,85.4c0,0,4.8,0,4.7,0.1v-3.2h-4.8v-2h5.3V77h-8.7v13.8h8.8v-3.3H202V85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.4,83.5c-0.5-0.4-0.9-0.5-1.4-0.7c-0.4-0.1-0.9-0.2-1.6-0.5c-0.9-0.2-1.5-0.5-1.8-0.7    c-0.4-0.2-0.5-0.4-0.5-0.7c0-0.2,0.1-0.5,0.4-0.6c0.2-0.1,0.6-0.2,1-0.2c1,0,1.6,0.6,2.1,1.6l2.9-1.7c-0.5-1-1.2-1.7-2.1-2.3    c-0.9-0.6-2-0.9-3.1-0.9c-1.4,0-2.5,0.5-3.4,1.2c-0.9,0.7-1.4,1.8-1.4,3.1c0,1.1,0.4,2,1.1,2.7c0.7,0.7,1.7,1.2,3.1,1.6    c1,0.2,1.5,0.4,1.7,0.5c0.6,0.2,1,0.6,1,1c0,0.6-0.5,1-1.6,1c-1.4,0-2.2-0.6-2.7-1.8l-2.9,1.7c0.5,1.1,1.1,2.1,2.1,2.6    c1,0.5,2.1,0.9,3.6,0.9c1.6,0,2.8-0.4,3.6-1.4c1-0.7,1.5-1.8,1.5-3.2C218.9,85.1,218.4,84.1,217.4,83.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110,21.8c0.1-0.7-0.2-1.1-0.9-1.1H92.5c-0.7,0-1.1,0.3-1.3,1.1c-0.1,0.7,0.2,1.1,0.9,1.1h16.5    C109.4,23,109.8,22.6,110,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.5,24.6c0.1-0.7-0.2-1.1-0.9-1.1H92c-0.7,0-1.1,0.3-1.3,1.1c-0.1,0.8,0.1,1.1,0.9,1.1h16.5    C108.9,25.7,109.4,25.4,109.5,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2,37.2h-5.5c-0.7,0.1-1.2,0.4-1.3,1.1c-0.1,0.7,0.1,1.1,0.9,1.1h5.5c0.7,0,1.2-0.3,1.3-1.1    C107.2,37.6,106.9,37.2,106.2,37.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,28.5h5.5c0.7,0,1.1-0.3,1.3-1.1c0.1-0.7-0.1-1.1-0.9-1.1h-5.5c-0.7,0-1.2,0.4-1.3,1.1    C90.1,28.1,90.4,28.5,91.2,28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.6,34.5h-14c-0.7,0-1.1,0.4-1.3,1.1c-0.1,0.7,0.1,1.1,0.9,1.1h14c0.7,0,1.2-0.3,1.3-1.1    C107.6,34.9,107.3,34.5,106.6,34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.6,20.7c-0.7,0-1.1,0.3-1.3,1.1c-0.1,0.7,0.1,1.1,0.9,1.1h16.5c0.7,0,1.1-0.3,1.3-1.1    c0.1-0.7-0.2-1.1-0.9-1.1H115.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.4,18H95.8c-0.7,0-1.2,0.3-1.3,1.1c-0.1,0.7,0.2,1.1,0.9,1.1h13.7c0.7,0,1.1-0.3,1.3-1.1    C110.5,18.4,110.2,18,109.4,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108,32.9c0.1-0.7-0.2-1.1-0.9-1.1H90.6c-0.7,0-1.1,0.4-1.3,1.1c-0.1,0.7,0.2,1.1,0.9,1.1h16.4    C107.4,34,107.8,33.7,108,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.7,31.2h13.7c0.7,0,1.1-0.3,1.3-1.1c0.1-0.7-0.1-1.1-0.9-1.1H91.1c-0.7,0.1-1.2,0.4-1.3,1.1    C89.6,30.8,90,31.2,90.7,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.9,43.9c-0.1,0.7,0.2,1.1,0.9,1.1h5.5c0.7,0,1.1-0.4,1.3-1.1c0.1-0.7-0.2-1.1-0.9-1.1h-5.5    C116.5,42.7,116.1,43.1,115.9,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.9,32.9c-0.1,0.7,0.2,1.1,0.9,1.1h5.5c0.7,0,1.1-0.3,1.3-1.1c0.1-0.7-0.2-1.1-0.9-1.1h-5.5    C118.4,31.7,118,32.1,117.9,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.7,28.5h5.5c0.7,0,1.1-0.3,1.3-1.1c0.1-0.7-0.1-1.1-0.9-1.1h-5.5c-0.7,0-1.2,0.3-1.3,1.1    C118.7,28.1,119,28.5,119.7,28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.6,42.7c-0.7,0-1.1,0.4-1.3,1.1c-0.1,0.8,0.1,1.1,0.9,1.1h16.5c0.7,0,1.1-0.4,1.3-1.1    c0.1-0.7-0.2-1.1-0.9-1.1H88.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.4,35.6c-0.1,0.7,0.1,1.1,0.9,1.1h5.5c0.7,0,1.2-0.3,1.3-1.1c0.1-0.7-0.2-1.1-0.9-1.1h-5.5    C117.9,34.5,117.5,34.9,117.4,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.4,41.1c-0.1,0.7,0.2,1.1,0.9,1.1h5.5c0.7,0,1.1-0.4,1.3-1.1c0.1-0.7-0.1-1.1-0.9-1.1h-5.5    C117,39.9,116.5,40.3,116.4,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.9,38.3c-0.2,0.7,0.1,1.1,0.9,1.1h5.5c0.7,0,1.2-0.3,1.3-1.1c0.1-0.7-0.2-1.1-0.9-1.1h-5.5    C117.5,37.2,117.1,37.5,116.9,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.3,31.2h5.5c0.7,0,1.1-0.3,1.3-1.1c0.1-0.7-0.1-1.1-0.9-1.1h-5.5c-0.7,0-1.2,0.3-1.3,1.1    C118.2,30.8,118.5,31.2,119.3,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.5,46.6c-0.1,0.7,0.2,1.1,0.9,1.1h5.5c0.7,0,1.1-0.4,1.3-1.1c0.1-0.7-0.2-1.1-0.9-1.1h-5.5    C116,45.5,115.5,45.9,115.5,46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.2,27L141.2,27c-0.7-6.2-9.4-3.6-9.4-3.6l0,0c0,0,0,0-0.1,0h-16.5c-0.7,0-1.1,0.3-1.3,1.1    c-0.2,0.8,0.1,1.1,0.9,1.1h16.5c0,0,0,0,0.1,0l0,0c0,0,0,0,0,0c0.4,0,0.8-0.1,1-0.4c4.2-1.7,5.6,0.4,6,2c0.3,1.7,0.4,3.4,0.4,5.1    c0,16-13.1,29.1-29.2,29.1c-8.7,0-16.5-3.7-21.8-9.8l-0.2-0.2l-0.3-0.3L87.1,51c-0.1-0.1-0.5-0.4-0.7-0.7c-0.6-0.7-1-1.7,0.3-2.4    c0.7-0.2,1.5-0.2,1.5-0.2h13.4c0.7,0,1.1-0.4,1.3-1.1c0.1-0.7-0.2-1.1-0.9-1.1H88.2c0,0,0,0,0,0c-0.2,0-0.4,0-0.7,0l0,0    c0,0-1.5,0-2.5,0.3l0,0c-2,0.5-3.9,1.8-1.2,5.1l0,0c5.8,8.1,15.2,13.4,26,13.4c17.6,0,32-14.3,32-32    C141.6,30.6,141.5,28.8,141.2,27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.6,40.1c1.8,4.9,7.7,2.8,9.7,2c0.1,0.1,0.3,0.1,0.5,0.1h16.5c0.7,0,1.1-0.4,1.3-1.1    c0.1-0.7-0.1-1.1-0.9-1.1H89.2c-0.5,0-0.8,0.1-1.1,0.5c-4.6,3.5-6.7-0.7-6.7-0.7l0,0c-0.7-2.3-1-4.8-1-7.3    c0.1-16.1,13.1-29.2,29.2-29.2c9.8,0,18.4,4.9,23.8,12.3h0c0.4,0.7,0.8,1.8-0.5,2.6c-0.1,0-0.1,0-0.2,0h-16.5    c-0.7,0-1.1,0.3-1.3,1.1c-0.1,0.7,0.2,1.1,0.9,1.1h16.4c0,0,6.3,0.4,5.3-3.1c-0.2-0.5-0.5-1.1-1-1.9c0,0,0,0,0-0.1    c-5.7-8.9-15.6-14.7-26.9-14.7c-17.6,0-32,14.3-31.9,32C77.6,35.1,77.9,37.7,78.6,40.1L78.6,40.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkynetTechnologiesLogo2);
export default __webpack_public_path__ + "static/media/Skynet-Technologies-Logo-2.23c0e6c92c66d94b910e4e8767f38e38.svg";
export { ForwardRef as ReactComponent };